import { render, staticRenderFns } from "./FlagshipProfilingStepGoals.vue?vue&type=template&id=5827155f&scoped=true&"
import script from "./FlagshipProfilingStepGoals.vue?vue&type=script&lang=ts&"
export * from "./FlagshipProfilingStepGoals.vue?vue&type=script&lang=ts&"
import style0 from "./FlagshipProfilingStepGoals.vue?vue&type=style&index=0&id=5827155f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5827155f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VCol,VRow,VTextField})
